import { CSSProperties, ReactNode, useEffect, useRef, useState } from "react";
import { InterfaceButton, InterfaceScroller, InterfaceStyles, InterfaceTextInput } from "../Components/Interface";
import { Colours } from "../Themes/Colours";
import { useIsHovering, useIsVisible } from "../Utils/Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsDownToLine, faArrowsUpDownLeftRight, faBars, faBattery, faBattery0, faBattery2, faBattery4, faBell, faBoltLightning, faBorderAll, faBorderNone, faCheck, faChevronDown, faCircle, faCircleHalfStroke, faCircleUser, faClapperboard, faClock, faCloudArrowUp, faCode, faCrop, faEnvelope, faExpand, faEye, faFile, faFilm, faFolder, faFolderOpen, faForwardStep, faGears, faGridHorizontal, faHandPointer, faHourglassHalf, faIdCard, faInfo, faInfoCircle, faKey, faKeyboard, faLayerGroup, faLeaf, faPaintBrush, faPalette, faPause, faPerson, faPhotoFilm, faPlayCircle, faRefresh, faRepeat, faScissors, faSignal, faSitemap, faSliders, faStopwatch, faSun, faSwatchbook, faTemperature0, faTimes, faUser, faVideo, faWarning, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { faAccessibleIcon, faAndroid, faApple, faAppStoreIos, faHtml5, faWindows } from "@fortawesome/free-brands-svg-icons";
import { CallToActionOneCopy, CallToActionThreeCopy, CallToActionTwoCopy } from "../Copy/Copy";
import { SiteStyles, useSite } from "../Context/SiteContext";

export const LandingPage = () => {

    return(
        <div style={{
            position:'absolute',
            display:'flex',
            inset:0,
            overflow:'hidden',
            fontFamily:'Science Gothic',
            backgroundColor:"#111318",
        }}>
            <div style={{
                position:'absolute',
                bottom:'-50vh',
                height:'100vh',
                width:'100vw',
                borderRadius:'100%',
                backgroundColor:Colours.blueHighlightBg,
                filter:'blur(100px)',
                opacity:0.5,
                zIndex:1,
                pointerEvents:'none',
                mixBlendMode:'overlay',
            }}></div>
            <InterfaceScroller scrollerStyle={{padding:0, alignItems:'center',}}>
                <LandingBanner></LandingBanner>     
                <Follower>
                    <CallToAction></CallToAction>
                    <Features></Features>
                </Follower>           
                <Beta></Beta>
                <Disclaimer></Disclaimer>
            </InterfaceScroller>
        </div>
    );

};

const LandingBanner = () => {

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoVisible ? videoRef.current?.play() : videoRef.current?.pause();
    },[videoVisible]);

    return(
        <div style={{
            display:'flex',
            position:'relative',
            minHeight:'100vh',
            width:'100vw',
            overflow:'hidden',
            alignItems:'center',
            justifyContent:'center',
        }}>
            <video 
                ref={videoRef}
                src="assets/provence-banner-1.mp4"
                style={{
                    width:'100%',
                    height:'100%',
                    objectFit:'cover',
                    opacity:0.7,
                }}
                muted
                loop
                playsInline
                autoPlay
                preload="auto"
            ></video>
            <img src="assets/bg-fade.png" style={{
                position:'absolute',
                width:'105%',
                height:'40vh',
                bottom:-5,
                objectFit:'fill',
            }}></img>
            <BannerMenu></BannerMenu>
             <div 
                style={{
                    position:'absolute',
                    maxWidth:'85%',
                    bottom:80,
                    color:Colours.orangeHighlightBg,
                    fontFamily:'Science Gothic',
                    textAlign:'center',
                    fontSize:20,
                    fontWeight:600,
                    userSelect:'none',
                    mixBlendMode:'lighten',
                    cursor:'pointer',
                }}
                onClick={()=>{
                    document.getElementById('beta')?.scrollIntoView({behavior:'smooth'});
                }}
            >DAILY LICENCES AVAILABLE</div>
            <img src="assets/logos/barcode-blue-tall.png" style={{
                position:'absolute',
                width:'80%',
                maxWidth:1200,
                height:'70%',
                objectFit:'contain',
                mixBlendMode:'plus-lighter',
                filter:'hue-rotate(184deg)',
            }}></img>
            <BannerPlatformIcons></BannerPlatformIcons>
            <FontAwesomeIcon icon={faChevronDown} style={{
                position:'absolute',
                bottom:15,
                color:Colours.blueHighlightBg,
                userSelect:'none',
                mixBlendMode:'lighten',
                opacity:0.4,
                fontSize:12,
            }}></FontAwesomeIcon>
        </div>
    );
};

const BannerMenu = () => {

    const Site = useSite();

    const [showBarMenu, setShowBarMenu] = useState(false);

    return(
        <div style={{
            position:'absolute',
            top:30,
            width:'100%',
            overflow:'hidden',
            zIndex:2,
        }}>
            <div style={{
                ...InterfaceStyles.standardRow,
                justifyContent:'center',
                height:undefined,
                paddingTop: Site.windowWidth > 800 ? 0 : 40,
                flexDirection: Site.windowWidth > 800 ? 'row': 'column',
                alignItems: Site.windowWidth > 800 ? 'center': 'flex-end',
            }}>
                <div style={InterfaceStyles.flexOne}></div>
                <BannerMenuButton showMenuBar={showBarMenu} title="Features" onClick={()=>{
                    document.getElementById('features')?.scrollIntoView({behavior:'smooth'});
                    setShowBarMenu(false);
                }}></BannerMenuButton>
                <BannerMenuButton showMenuBar={showBarMenu} title="Downloads" style={{transitionDelay:'100ms'}} onClick={()=>{
                    document.getElementById('beta')?.scrollIntoView({behavior:'smooth'});
                    setShowBarMenu(false);
                }}></BannerMenuButton>
                <BannerMenuButton showMenuBar={showBarMenu} title="Documentation" style={{transitionDelay:'200ms'}} onClick={()=>{
                    document.getElementById('beta')?.scrollIntoView({behavior:'smooth'});
                    setShowBarMenu(false);
                }}></BannerMenuButton>
                <BannerMenuButton showMenuBar={showBarMenu} title="Pricing" style={{transitionDelay:'300ms'}} onClick={()=>{
                    document.getElementById('beta')?.scrollIntoView({behavior:'smooth'});
                    setShowBarMenu(false);
                }}></BannerMenuButton>                
                <BannerMenuButton showMenuBar={showBarMenu} icon={faCircleUser} style={{justifyContent:'flex-start', transitionDelay:'400ms'}} onClick={()=>{
                    document.getElementById('beta')?.scrollIntoView({behavior:'smooth'});
                    setShowBarMenu(false);
                }}></BannerMenuButton>
            </div>
            <div style={{
                position:'absolute',
                top:0,
                right:30,
                display: Site.windowWidth > 800 ? 'none' : 'flex',
                fontSize: 28,
                color:Colours.blueHighlightBg,
            }} onClick={()=>setShowBarMenu(!showBarMenu)}>
                <FontAwesomeIcon icon={showBarMenu ? faTimes : faBars}></FontAwesomeIcon>
            </div>
        </div>
    );

};

const BannerMenuButton = (props:{title?:string, icon?:IconDefinition, showMenuBar:boolean, style?:CSSProperties, onClick?:()=>void}) => {

    const Site = useSite();

    const elRef = useRef<HTMLDivElement>(null)
    const hovering = useIsHovering(elRef);
    const [isMobile, setIsMobilie] = useState(false);

    useEffect(()=>{

    },[Site.windowWidth]);

    return(
        <div ref={elRef} className="banner-menu-button" onClick={props.onClick} style={{
            display:'flex',
            flex:1,
            flexShrink:0,
            fontSize: 20,
            marginRight: Site.windowWidth > 800 ? 0 : props.showMenuBar ? 35 : -400,
            textTransform:'uppercase',
            color:hovering? Colours.orangeHighlightBg : Colours.blueHighlightBg,
            justifyContent:'center',
            alignItems:'center',
            mixBlendMode:'lighten',
            boxSizing:'border-box',
            userSelect:'none',
            cursor:'pointer',
            transition:  `color 0.3s ease, ${Site.windowWidth > 800 ? 'margin-right 0s' : 'margin-right 1s ease'}`,
            ...props.style,
        }}>
            {props.title}
            {props.icon && <FontAwesomeIcon icon={props.icon}></FontAwesomeIcon>}
        </div>
    );

};

const BannerPlatformIcons = () => {

    const iconStyle = {        
        color:Colours.blueHighlightBg,
        userSelect:'none',
        mixBlendMode:'lighten',
        fontSize:24,
    } as CSSProperties;

    return(
        <div style={{
            ...InterfaceStyles.standardRow,
            position:'absolute',
            bottom:30,
        }}>
            <FontAwesomeIcon icon={faWindows} style={{...iconStyle}}></FontAwesomeIcon>
            <FontAwesomeIcon icon={faApple} style={{...iconStyle}}></FontAwesomeIcon>
            <FontAwesomeIcon icon={faAppStoreIos} style={{...iconStyle}}></FontAwesomeIcon>
            <FontAwesomeIcon icon={faAndroid} style={{...iconStyle}}></FontAwesomeIcon>
        </div>
    );

};

export const RevealSection = (props:{id?:string, type?: 'wide' | 'narrow', vertPadding?:boolean, style?:CSSProperties, children?:ReactNode}) => {

    const Site = useSite();    
    const sectionRef = useRef<HTMLDivElement>(null);
    const sectionVisible = useIsVisible(sectionRef);

    const [show, setShow] = useState(false);

    useEffect(()=>{
        sectionVisible && setShow(true);
    },[sectionVisible])

    return(
        <div id={props.id} ref={sectionRef} style={{
            ...(props.type === 'wide' ? Site.styles?.landingWideContext : Site.styles?.landingNarrowContext), 
            paddingTop:props.vertPadding ? 40 : 0,
            paddingBottom:props.vertPadding ? 40 : 0,
            opacity: show ? 1 : 0,
            transition: 'opacity 1s ease',
            transitionDelay:'250ms',
            ...props.style
        }}>
            {props.children}
        </div>
    );

};

export const CenterBlueTitle = (props:{title:string,rowStyle?:CSSProperties, titleStyle?:CSSProperties}) => {

    const Site = useSite();

    return(
        <div style={{...Site.styles?.landingTitleRow,justifyContent:'center',...props.rowStyle}}>
            <div style={{...Site.styles?.revealTitleBlue,...props.titleStyle}}>{props.title}</div>
        </div>
    );

};

const SideBySide = (props:{leftChildren?:ReactNode,rightChildren?:ReactNode,reverseBig?:boolean}) => {
    
    const Site = useSite();

    const [isRow, setIsColumn] = useState(false);

    useEffect(()=>{
        setIsColumn(Site.windowWidth > 1200);
    },[Site.windowWidth]);

    return(
        <div style={{
            ...Site.styles?.landingWideContext,
            ...InterfaceStyles.center,
            flexDirection: isRow ? props.reverseBig ? 'row-reverse' : 'row' : 'column',
            padding:40,
            gap:40,
        }}>
            {props.leftChildren && (
                <RevealSection style={{
                    flex: isRow ? 1 : undefined,
                    alignItems: 'center',
                    padding:0,
                }}>
                    {props.leftChildren}
                </RevealSection>
            )}
            {props.rightChildren && (
                <RevealSection style={{
                    flex: isRow ? 1 : undefined,
                    alignItems: 'center',
                    padding:0,
                }}>
                    {props.rightChildren}
                </RevealSection>
            )}
        </div>
    );
};

const CallToAction = () => {

    const Site = useSite();

    const titleRef = useRef<HTMLDivElement>(null);
    const isTitleVisible = useIsVisible(titleRef);

    const [show, setShow] = useState(false);

    useEffect(()=>{
        isTitleVisible && setShow(true);
    },[isTitleVisible]);
    
    const titleStyles = {
        ...Site.styles?.revealTitleBlue,
        opacity: show ? 1 : 0,
    } as CSSProperties;

    return(
        <div style={{...Site.styles?.landingNarrowContext,paddingTop:100,}}>
            <div style={{...titleStyles, transitionDelay: '0ms'}}>REALTIME</div>
            <div style={{...titleStyles, transitionDelay: '500ms'}}>INTERACTIVE</div>
            <div style={{...titleStyles, transitionDelay: '1000ms'}} ref={titleRef}>Data-Driven</div>
            <div style={{...titleStyles, transitionDelay: '1500ms'}}>inter-device</div>
            <div style={{...titleStyles, transitionDelay: '2000ms'}}>communication</div>
            <div style={{...titleStyles, transitionDelay: '2500ms',display:'flex',height:40, justifyContent:'center', marginTop:30,marginBottom:40,}}>
                <img src="assets/logos/play-logo-blue.png" style={{height:'100%',objectFit:'contain'}}></img>
            </div>
            <div style={{
                ...InterfaceStyles.standardColumn,
                gap:20,                
                opacity: show ? 1 : 0,
                transition: 'opacity 1s ease',
                transitionDelay: '2.5s',
            }}>
                
                <div style={{
                    ...Site.styles?.copyText,
                }}>{CallToActionOneCopy}</div>
                <div style={{
                    ...Site.styles?.copyText,
                }}>{CallToActionTwoCopy}</div>
                <div style={{
                    ...Site.styles?.copyText,
                }}>{CallToActionThreeCopy}</div>
            </div>
        </div>
    );
};

const Features = () => {

    const Site = useSite();

    return(
        <div id="features" style={Site.styles?.landingWideContext}>
            <RevealSection vertPadding={true}>
                <CenterBlueTitle title="Playback on any device"></CenterBlueTitle>
            </RevealSection>
            <MediaPlayback></MediaPlayback>
            <Triggering></Triggering>
            <ImageCorrection></ImageCorrection>
            <FileManagement></FileManagement>
            <ClientSettings></ClientSettings>
            <Monitoring></Monitoring>
        </div>
    )

};

const FeatureSubtitle = (props:{icon?:IconDefinition,title:string,}) => {

    const Site = useSite();

    return(
        <div style={{...Site.styles?.landingTitleRow}}>
            <FontAwesomeIcon icon={props.icon ?? faBoltLightning} style={{...Site.styles?.landingTitleIcon,fontSize:16}}></FontAwesomeIcon>
            <div style={{
                color:Colours.levelFourText,
                fontSize:20,
                cursor:'default',
            }}>{props.title}</div>
        </div>
    );

};

const FeatureHighlight = (props:{icon?:IconDefinition,title:string, copy?:string}) => {
    
    const Site = useSite();

    const [hovering, setHovering] = useState(false);
    
    return(
        <div 
            style={{
                ...InterfaceStyles.floatingSection,
                ...InterfaceStyles.center,
                padding:10,
                width:'100%',
                backgroundColor:undefined,
                alignItems:'flex-start',
                justifyContent:'flex-start',
                gap:5,
                border: hovering ? `1px solid ${Colours.blueHighlightBg}` : `1px solid ${Colours.levelThreeBg}`,
                transform: hovering ? 'translateY(-2px)' : 'translateY(0px)',
                transition:'transform 0.5s ease, border 0.5s ease',
                ...InterfaceStyles.shadow,
            }}
            onMouseEnter={()=>setHovering(true)}
            onMouseLeave={()=>setHovering(false)}
        >
            <div style={{
                display:'flex',
                flexDirection:'row',
                gap:5,
                alignItems:'center',
            }}>
                <FontAwesomeIcon icon={props.icon ?? faBoltLightning} style={{...Site.styles?.landingTitleIcon,fontSize:16}}></FontAwesomeIcon>
                <div style={{
                    color:Colours.levelFourText,
                    fontSize:20,
                    cursor:'default',
                }}>{props.title}</div>
            </div>
            {props.copy && (
                <div style={{
                    ...Site.styles?.copyText,
                    textAlign:'left',
                    fontSize:16,
                    color:Colours.levelThreeText,
                }}>{props.copy}</div>
            )}
        </div>
    );
};

const MediaPlayback = () => {

    const Site = useSite();

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoRef.current && (videoRef.current.currentTime = 0);
        videoRef.current?.play();
    },[videoVisible]);

    return(
        <SideBySide 
            leftChildren={
                <video
                    ref={videoRef} 
                    src="assets/cutting-room.mp4" 
                    playsInline loop autoPlay muted preload="auto"
                    style={{
                        width:'100%',
                        objectFit:'contain',
                        borderRadius:5,
                    }}
                ></video>
            }
            rightChildren={
                <>
                    <FeatureSubtitle icon={faPhotoFilm} title="Media Playback"></FeatureSubtitle>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faVideo} title="Video / Images" copy="MP4, MOV, VP9, JPG, PNG, and more."></FeatureHighlight>
                        <FeatureHighlight icon={faHtml5} title="Web Assets" copy="Playback websites by file or URL. Cue playback from websites."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faPause} title="Play / Pause" copy="Remote play and pause on all screens."></FeatureHighlight>
                        <FeatureHighlight icon={faScissors} title="In & Out" copy="Set video in and out points."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faRepeat} title="Loop" copy="Loop videos using in and out points, or hold at end."></FeatureHighlight>
                        <FeatureHighlight icon={faStopwatch} title="Speed" copy="Adjust video play speed."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faLayerGroup} title="Alpha Layers" copy="Layered playback with transparency."></FeatureHighlight>
                        <FeatureHighlight icon={faForwardStep} title="Autoplay" copy="Play new asset or trigger cues at the end of asset duration."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faHourglassHalf} title="Transitions" copy="Set smooth crossfade transition times."></FeatureHighlight>
                    </div>
                </>
            }
        ></SideBySide>
    );

};

const ImageCorrection = () => {

    const Site = useSite();

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoRef.current && (videoRef.current.currentTime = 0);
        videoRef.current?.play();
    },[videoVisible]);
    
    return(
        <SideBySide 
            leftChildren={
                <>
                    <video 
                        ref={videoRef}
                        src="assets/transform.mp4" 
                        playsInline loop autoPlay muted preload="auto"
                        style={{
                            width:'100%',
                            objectFit:'contain',
                            borderRadius:5,
                        }}
                    ></video>
                </>
            }
            rightChildren={
                <>
                    <FeatureSubtitle icon={faPaintBrush} title="Image Correction"></FeatureSubtitle>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faArrowsUpDownLeftRight} title="Transform" copy="Set position, rotation and scale using responsive sizing units."></FeatureHighlight>
                        <FeatureHighlight icon={faBorderAll} title="Multiscreen" copy="Spread videos across multiple screens/devices."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faExpand} title="Fit" copy="Contain. Cover. Fill. Fine tune how an asset fits within its dimensions."></FeatureHighlight>
                        <FeatureHighlight icon={faCrop} title="Crop" copy="Clean up assets or add dramatic effect. Adjust an asset to fit perfectly."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faCircleHalfStroke} title="Brightness / Contrast" copy="Set each asset's brightness and contrast."></FeatureHighlight>
                        <FeatureHighlight icon={faTemperature0} title="Colour Temperature" copy="Quickly set all screens to match camera settings."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faSliders} title="Colour Matrix" copy="Adjust red, green and blue levels individually."></FeatureHighlight>
                        <FeatureHighlight icon={faSwatchbook} title="Hue Rotate" copy="Modify an asset's overall look by rotating through hues."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faCircle} title="Opacity" copy="Make an asset see through."></FeatureHighlight>
                        <FeatureHighlight icon={faBorderNone} title="Blur" copy="Blur a face or make a landscape look out of focus."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faPalette} title="Saturation" copy="Make colours pop; go black and white; or anything inbetween."></FeatureHighlight>
                        <FeatureHighlight icon={faRefresh} title="Invert Colours" copy="Invert an asset's colours."></FeatureHighlight>
                    </div>
                </>
            }
        ></SideBySide>
    );

};

const Triggering = () => {

    const Site = useSite();

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoRef.current && (videoRef.current.currentTime = 0);
        videoRef.current?.play();
    },[videoVisible]);

    return(
        <SideBySide 
            reverseBig
            leftChildren={
                <video 
                    ref={videoRef}
                    src="assets/cueing.mp4" 
                    playsInline loop autoPlay muted preload="auto"
                    style={{
                        width:'100%',
                        objectFit:'contain',
                        borderRadius:5,
                    }}
                ></video>
            }
            rightChildren={
                <>
                    <FeatureSubtitle icon={faClapperboard} title="Cueing and Interactivity"></FeatureSubtitle>
                    <FeatureHighlight icon={faGridHorizontal} title="Touch Pad" copy="Assign clips to be triggered remotely by the Provence Touch Pad. Built into every client."></FeatureHighlight>
                    <FeatureHighlight icon={faCode} title="Advanced Interaction" copy="Use Provence hooks in interactive web assets to send data over the Touch Pad. Have real text conversations. Send touch position data. Draw on the screen and see it replicated on any number of screens. Operate a spaceship. Let actors drive the scene while letting operators make sure nothing is missed."></FeatureHighlight>
                    <FeatureHighlight icon={faHandPointer} title="Actor Touch" copy="Quickly set actor touch to trigger Touch Pad cues. Triggers changes on any device."></FeatureHighlight>
                    <FeatureHighlight icon={faKeyboard} title="Keyboard" copy="Use a keyboard to trigger the Touch Pad or to cue playback on the device it's attached to."></FeatureHighlight>
                </>
            }
        ></SideBySide>
    );

};

const ClientSettings = () => {

    const Site = useSite();

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoRef.current && (videoRef.current.currentTime = 0);
        videoRef.current?.play();
    },[videoVisible]);

    return(
        <>
            <RevealSection vertPadding={true}>
                <CenterBlueTitle title="Every Device is a controller"></CenterBlueTitle>
            </RevealSection>
            <SideBySide
                reverseBig
                leftChildren={
                    <video 
                        ref={videoRef}
                        src="assets/client-settings.mp4" 
                        playsInline loop autoPlay muted preload="auto"
                        style={{
                            width:'100%',
                            objectFit:'contain',
                            borderRadius:5,
                        }}
                    ></video>
                }
                rightChildren={
                    <>
                        <FeatureSubtitle icon={faGears} title="Client Settings"></FeatureSubtitle>
                        <div style={{...Site.styles?.rotator}}>
                            <FeatureHighlight icon={faIdCard} title="Identification" copy="Give each client a unique ID which can be changed at a whim."></FeatureHighlight>
                            <FeatureHighlight icon={faSignal} title="Network Information" copy="View each client's IP address, connection status and latency."></FeatureHighlight>
                        </div>
                        <div style={{...Site.styles?.rotator}}>
                            <FeatureHighlight icon={faBattery4} title="Battery Level" copy="Monitor battery level of all mobile devices remotely."></FeatureHighlight>
                            <FeatureHighlight icon={faSun} title="Device Brightness" copy="Adjust the screen brightness of all mobile devices."></FeatureHighlight>
                        </div>
                        <div style={{...Site.styles?.rotator}}>
                            <FeatureHighlight icon={faClock} title="Sync" copy="One button to sync groups of clients ensuring cues are well timed."></FeatureHighlight>
                            <FeatureHighlight icon={faHourglassHalf} title="Delay" copy="Delay cues on individual clients."></FeatureHighlight>
                        </div>
                    </>
                }
            ></SideBySide>
        </>
    );

};

const FileManagement = () => {

    const Site = useSite();

    return(
        <SideBySide
            reverseBig
            
            rightChildren={
                <>
                    <FeatureSubtitle icon={faFolderOpen} title="File Management"></FeatureSubtitle>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faSitemap} title="Browser Explorer" copy="Using any web browser, any device on the network can access a remote file explorer made available from the server."></FeatureHighlight>
                        <FeatureHighlight icon={faKey} title="Access Control" copy="Define which individual folders, and their children, on the server computer are available for access through the remote file explorer. Allowing flexible file management."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faEye} title="File Monitoring" copy="Files are monitored to ensure data is up to date."></FeatureHighlight>
                        <FeatureHighlight icon={faFile} title="Edit Files" copy="Rename, delete, move and create files/folders remotely."></FeatureHighlight>
                    </div>
                    <div style={{...Site.styles?.rotator}}>
                        <FeatureHighlight icon={faCloudArrowUp} title="Upload/Download" copy="Upload files that can immediately be used for playback. Download any file or folder on the server."></FeatureHighlight>
                        <FeatureHighlight icon={faPlayCircle} title="Quick View" copy="Open or play any file in the explorer directly in the web browser."></FeatureHighlight>
                    </div>
                </>
            }
        ></SideBySide>
    );

};

const Monitoring = () => {

    const Site = useSite();

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoRef.current && (videoRef.current.currentTime = 0);
        videoRef.current?.play();
    },[videoVisible]);

    return(
        <>
            <RevealSection vertPadding={true}>
                <CenterBlueTitle title="Monitor every screen from anywhere"></CenterBlueTitle>
            </RevealSection>
            <SideBySide
                leftChildren={
                    <video 
                        ref={videoRef}
                        src="assets/monitoring.mp4" 
                        playsInline loop autoPlay muted preload="auto"
                        style={{
                            width:'100%',
                            objectFit:'contain',
                            borderRadius:5,
                        }}
                    ></video>
                }
                rightChildren={
                    <>
                        <FeatureSubtitle icon={faEye} title="Screen Monitoring"></FeatureSubtitle>
                        <div style={{...Site.styles?.rotator}}>
                            <FeatureHighlight icon={faGridHorizontal} title="Overview" copy="All screens layed out evenly to get a view of everything happening."></FeatureHighlight>
                            <FeatureHighlight icon={faInfoCircle} title="Client Information" copy="See diagnostic information of every screen."></FeatureHighlight>
                        </div>
                        <div style={{...Site.styles?.rotator}}>
                            <FeatureHighlight icon={faBell} title="Connection Monitoring" copy="No network is perfect. Be notified swiftly if a device loses connection."></FeatureHighlight>
                            <FeatureHighlight icon={faClock} title="Adjustable Update Rate" copy="Set how often the monitor checks in on the screens."></FeatureHighlight>
                        </div>
                    </>
                }
            ></SideBySide>
        </>
    );

};

const Beta = () => {

    const Site = useSite();

    const [submitted, setSubmitted] = useState(false);
    const [hideInput, setHideInput] = useState(false);
    const textRef = useRef<HTMLInputElement>(null);

    useEffect(()=>{
        submitted && setTimeout(()=>setHideInput(true),1000);
    },[submitted])

    return(
        <RevealSection id="beta" vertPadding style={{
            position:'relative',
            minHeight:'100vh',
            alignItems:'center',
            justifyContent:'center',
        }}>
            <CenterBlueTitle title="JOIN THE BETA"></CenterBlueTitle>
            <div style={{...Site.styles?.copyText,paddingBottom:30,textAlign:'center'}}>
                Let us know that you want to join by submitting your email below
            </div>
            <div style={{
                ...InterfaceStyles.standardRow,
                width:'100%',
                opacity: submitted ? 0 : 1,
                transition:'opacity 1s ease',
                display: hideInput ? 'none' : 'flex',
            }}>
                <div style={InterfaceStyles.iconContainer}>
                    <FontAwesomeIcon icon={faEnvelope} style={{...Site.styles?.copyText}}></FontAwesomeIcon>
                </div>
                <InterfaceTextInput ref={textRef} value="" style={{textAlign:'left'}}></InterfaceTextInput>
                <InterfaceButton icon={faCheck} onClick={()=>{
                    const email = textRef.current?.value;
                    if(email && email.length > 0 && validateEmail(email)){
                        fetch('/beta',{
                            method:'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ email: email })
                        })
                        setSubmitted(true);
                    }
                }}></InterfaceButton>
            </div>
            <div 
                style={{
                    ...Site.styles?.copyText, 
                    height:40, 
                    opacity: hideInput ? 1 : 0, 
                    transition:'opacity 5s ease', 
                    transitionDelay:'1s',
                    display: hideInput ? 'flex' : 'none',
                }}
            >
                Thank You!
            </div>
            <a href="mailto:info@provencemediaserver.com" style={{position:'absolute', bottom:30,...Site.styles?.copyText}}>info@provencemediaserver.com</a>
        </RevealSection>
    );

};

const validateEmail = (email:string) => {
    const res = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return res.test(String(email).toLowerCase());
};

const Disclaimer = () => {

    const Site = useSite();

    return(
        <RevealSection vertPadding>
            <div style={{...Site.styles?.copyText,textAlign:'center',fontSize:12}}>
                The imagery and video presented on this website is the property of respective copyright holders. 
                It is unlawful to download, copy, distribute or reproduce any of the images or video without the explicit consent of the copyright holder. 
                By using this website you accept the above terms.
            </div>
            <div style={{...Site.styles?.copyText,textAlign:'center',fontSize:12,marginTop:20,}}>
                © 2026 Michael Yull
            </div>
        </RevealSection>
    )

};

const Follower = (props:any) => {

    const Site = useSite();

    const viewRef = useRef<HTMLDivElement>(null);
    const visible = useIsVisible(viewRef);

    return(
        <div {...props} ref={viewRef} style={{...InterfaceStyles.standardColumn,alignItems:'center'}}>
            <InterfaceButton 
                text="JOIN THE BETA" 
                style={{
                    position:'absolute',
                    top: visible ? 20: 10,
                    opacity: visible ? 1 : 0,
                    right:20,
                    borderRadius:20,
                    border:`1px solid ${Colours.orangeHighlightBg}`,
                    transition: 'all 0.5s ease',
                    flexDirection:'row-reverse',
                    gap:8,
                    zIndex:3,
                    ...InterfaceStyles.shadow,
                    pointerEvents : visible ? undefined : 'none'
                }} 
                textStyle={{color:'white'}}
                onClick={()=>{
                        document.getElementById('beta')?.scrollIntoView({behavior:'smooth'});
                }}
            >
                <img src="assets/logos/play-logo-white-small.png" style={{height:20,paddingLeft:5,}}></img>
            </InterfaceButton>
            {props.children}
        </div>
    );

};